import { Entity } from '../entity';
import { NotificationCategory } from './notification.category';

export interface NotificationDefinition extends Entity {
    _id: NotificationCategory;
    delivery: 'scheduled' | 'immediate'
    description: string;
}

export const NotificationDefinitions: NotificationDefinition[] = [
    {
        _id: NotificationCategory.Assignments,
        name: 'Assignments',
        description: 'Assignments and unassigments',
        delivery: 'scheduled'
    },
    {
        _id: NotificationCategory.StatusChanges,
        name: 'Status changes',
        description: 'Changes to status, priorities and other important fields',
        delivery: 'scheduled'
    },
    {
        _id: NotificationCategory.Comments,
        name: 'Activities',
        description: 'Activity creation and updates',
        delivery: 'scheduled'
    },
    {
        _id: NotificationCategory.Reminders,
        name: 'Reminders and deadlines',
        description: 'Reminders, missed start or due dates',
        delivery: 'scheduled'
    },
    {
        _id: NotificationCategory.Security,
        name: 'Application security changes',
        description: 'Security',
        delivery: 'immediate'
    },
    {
        _id: NotificationCategory.Integrations,
        name: 'Integrations',
        description: 'Requests related to workflow and integrations',
        delivery: 'scheduled'
    },
    {
        _id: NotificationCategory.AI,
        name: 'AI & Agents',
        description: 'AI task validation, agent actions, and agent messages',
        delivery: 'immediate'
    },
    {
        _id: NotificationCategory.BulkActions,
        name: 'Bulk actions',
        description: 'Bulk operation progress and results',
        delivery: 'immediate'
    },
];
